export default {
    isAuthenticated({ authUser }) {
        return authUser && authUser.email;
    },

    mustChangePassword({ authUser }) {
        return authUser && authUser.email && authUser.has_temporary_password;
    },
};
